"use strict";

var PropTypes = require("prop-types");

var classNames = require("classnames");
var LoggerInstance = require("js-logger").get("CategoryDropdown");

var CategoryStore = require("../stores/CategoryStore");

class CategoryDropdown extends React.Component {
	constructor(props) {
		super(props);

		// The top-level allowedCategories from wizard, or component properties
		var wizardCategories;
		if (props.wizardCategories) {
			wizardCategories = JSON.parse(props.wizardCategories);
		} else if (props.isDesignMode) {
			wizardCategories = CategoryStore.get("wizardCategories");
		}
		if (wizardCategories.allowedCategories) {
			wizardCategories = wizardCategories.allowedCategories;
		} else {
			wizardCategories = [];
		}
		var allowedCategories = props.allowedCategories;
		var categories = props.categories || CategoryStore.get("categories") || [];

		var hashArray = {};
		for (var indexy = 0; indexy < categories.length; indexy++) {
			var currentCategory = categories[indexy];
			if (hashArray[currentCategory.parentId] === undefined) {
				hashArray[currentCategory.parentId] = [];
			}
			if (!currentCategory.parentId) {
				// If this is a top-level category and it is not allowed by wizard or component properties, skip it.
				if (wizardCategories.indexOf(currentCategory.id) <= -1) {
					continue;
				} else if (allowedCategories && allowedCategories.indexOf(currentCategory.id) <= -1) {
					continue;
				}
			}
			hashArray[currentCategory.parentId].push(currentCategory);
		}

		// If we have allowedCategories, sort by them, otherwise, sort by wizardCategories
		var topLevelSortArray = allowedCategories || wizardCategories;
		categories = this.hierarchySort(
			hashArray,
			null, // top level key
			[], // results array
			0, // level
			topLevelSortArray);

		this.state = {
			activeCategory: null,
			categories,
			allowedCategories,
			wizardCategories
		};
	}

	handleSelectCategory(category) {
		this.setState({ activeCategory: category });
	}

	hierarchySortOrder(a,b) {
		return a.name > b.name;
	}

	hierarchySort(hashArray, key, result, level, topLevelSort) {
		if (hashArray[key] === undefined) return;
		var sortedArray;
		if (level > 0 || !topLevelSort) {
			sortedArray = hashArray[key].sort(this.hierarchySortOrder);
		} else {
			// Sorting the top-level using an array of ids
			sortedArray = hashArray[key].sort((a, b) => {
				if (topLevelSort.indexOf(a.id) < topLevelSort.indexOf(b.id)) {
					return -1;
				} else if (topLevelSort.indexOf(a.id) > topLevelSort.indexOf(b.id)) {
					return 1;
				}
				return 0;
			});
		}
		for (var index = 0; index < sortedArray.length; index++) {
			sortedArray[index].level = level;
			result.push(sortedArray[index]);
			this.hierarchySort(hashArray, sortedArray[index].id, result, level + 1);
		}

		return result;
	}

	componentDidMount() {
		// Inserting a span after the React node to keep bootstrap happy
		$(ReactDOM.findDOMNode(this)).after("<span></span>");
		if (this.props.isDesignMode) {
			parent.window.ComponentActions.childComponentLoaded(this);
		} else {
			var categories = this.state.categories;
			if (window._selectedCategoryId) {
				var activeCategory = categories.find(category => category.id === window._selectedCategoryId);
				delete window._selectedCategoryId;
				if (activeCategory) {
					this.setState({activeCategory});
				}
			}
		}
	}

	componentWillUnmount() {
		if (this.props.isDesignMode) {
			parent.window.ComponentActions.childComponentUnloaded(this);
		}
	}

	render() {
		var categories = this.state.categories;
		var activeCategory = this.state.activeCategory;
		var indentation = this.props.indentation;

		if (!this.props.isDesignMode && (!categories || categories.length <= 0)) {
			return null;
		}

		return (
			<div
				id={this.props.id}
				className="input-group-btn category-dropdown"
				data-react-component-name="CategoryDropdown"
				data-react-component-category="CategoryDropdownComponents"
				data-component-id={!this.props.isCustomTheme ? this.props.dataComponentId : undefined}
				data-nested-id={this.props.dataNestedId}
				data-theme={+this.props.theme ? this.props.theme : undefined}
				data-custom={this.props.isCustomTheme || null}
				data-child-of={this.props.dataChildOf}
			>
				<button type="button" className="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
					<span>{activeCategory ? activeCategory.name : "All"}</span>&nbsp;<span className="caret" />
				</button>
				<ul className="dropdown-menu">
					<li
						className={classNames("category", { active: !activeCategory })}
						onClick={this.handleSelectCategory.bind(this, null)}
						data-component="CategoryDropdown.category"
					>
						<a role="button">All</a>
					</li>
					{categories && categories.length > 0 &&
						categories.map((category) => {
							var padding = 20 + (indentation * category.level);
							return (
								<li
									key={category.id}
									className={classNames("category", { active: activeCategory === category })}
									onClick={this.handleSelectCategory.bind(this, category)}
									data-component="CategoryDropdown.category"
								>
									<a role="button" data-value={category.id} style={{ paddingLeft: padding }}>
										{category.name}
									</a>
								</li>
							);
						})
					}
				</ul>
			</div>
		);
	}
}

CategoryDropdown.defaultProps = {
	indentation: 24,
	theme: "0",
	isCustomTheme: false
};

CategoryDropdown.propTypes = {
	isDesignMode: PropTypes.bool,
	categories: PropTypes.array,
	allowedCategories: PropTypes.array,
	wizardCategories: PropTypes.string, // Serialized from wizard
	indentation: PropTypes.number,
	theme: PropTypes.string,
	isCustomTheme: PropTypes.bool,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	dataChildOf: PropTypes.string
};

module.exports = CategoryDropdown;
